const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Parse a comma-separated string of call IDs, returning only valid UUIDs (deduped). */
export const parseCallIdsParam = (raw: string | null): string[] => {
  if (!raw) return [];
  const ids = raw
    .split(',')
    .map((s) => s.trim())
    .filter((s) => UUID_RE.test(s));
  return [...new Set(ids)];
};
